import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ModalBody,Button } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { Timer } from 'components/Common';
import FPConfig from 'lib/config';

class GlobalLoader extends React.Component {
    render() {
        const timeout = FPConfig.timeout.getTxnStatus
        const {t} = this.props
        return (
            <>
                <ModalBody>
                    <div className="mb-4 text-center">
                        { this.props.merchantLogo && <img className="merchantLogo" src={this.props.merchantLogo} alt="Logo" /> }
                    </div>
                    {/* // Refrence to FT-26442 
                    <ul className="progressTiles">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                     </ul> */}
                     
                    <div className="progressLoader"></div>
                    <div style={{'textAlign': 'center'}}>
                        <p></p>
                        {
                            !this.props.transaction && 
                            <p className="text-16">{t('refresh_popup_content')}</p>
                        }
                        {
                            this.props.transaction &&   !this.props.isUpi &&
                            <>
                                {this.props.isCalledTxnStatus && <Timer secondsRemaining={timeout} />}
                                {t('bank_redirect_notes', {returnObjects: true}).map(({id, note}) => (
                                    <p className="text-16" key={id}>{note}</p>
                                ))}
                            </>
                        }
                        {
                            this.props.transaction &&   this.props.isUpi &&
                            <>
                                {this.props.isCalledTxnStatus && <Timer secondsRemaining={timeout} />}
                                <ul className="upi_text_list_container">
                                    {t('upi_redirect_notes', {returnObjects: true}).map(({id, note}) => (
                                            <li className="text-15 upi_text_list" key={id}>{note}</li>
                                    ))}
                                </ul>
                            </>
                        }

                        {
                            this.props.getTxnStatus && false && 
                            <>
                                <Button>Done</Button>
                            </>
                        }
                    </div>
                </ModalBody>
            </>
        )
    }
}

const mapStateToProps = state => {

    if (state.fdData && state.fdData.globalConfig) {

        const { SessionToken, ConfigId, txnKey, txnIv, selectedPayment, globalConfig: { mConfig: { mLogoUrl: merchantLogo, merchantName, integrationType } } } = state.fdData

        return { apiLoaded: true, redirectToRetryPayPage: false, merchantLogo, merchantName, integrationType, txnKey, txnIv, selectedPayment, SessionToken, ConfigId }

    } else {

        return { apiLoaded: false, redirectToRetryPayPage: false }

    }

}

export default connect(mapStateToProps)(withTranslation('translations')(modalWrapper(true, "GlobalLoaderModal")(GlobalLoader)))